import React from "react"
import { useSelector, useDispatch } from "react-redux"

import {
    SIL_MODEL_ACCOUNT_DEVICES,
    SIL_MODEL_ACCOUNT_SUBSYSTEMS,
    SIL_MODEL_PROJECT_DEVICES,
    SIL_MODEL_PROJECT_SUBSYSTEMS,
    SIL_MODEL_QID_PRODUCTS,

    StoreType,
    setSilModelDevicesActiveTab,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    PageMenu,
    PageMenuButton,
    Tab,
} from "client/components"

import AccountDevices from "./silDevices/accountDevices"
import AccountSubsystems from "./silDevices/accountSubsystems"
import ProjectDevices from "./silDevices/projectDevices"
import ProjectSubsystems from "./silDevices/projectSubsystems"
import QidProducts from "./qidProducts"


const ModelDevices = () => {
    let activeTab = useSelector((state: StoreType) => state.silModelDevices.activeTab)

    const accountDevices = useSelector((state: StoreType) => state.silModelDevices.accountDevices.deviceList)
    const accountSubsystems = useSelector((state: StoreType) => state.silModelDevices.accountSubsystems.deviceList)
    const projectDevices = useSelector((state: StoreType) => state.silModelDevices.projectDevices.deviceList)
    const projectSubsystems = useSelector((state: StoreType) => state.silModelDevices.projectSubsystems.deviceList)
    const qidProducts = useSelector((state: StoreType) => state.silModelDevices.qidProducts.productList)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const setActiveTab = (tab: string) => {
        dispatch(setSilModelDevicesActiveTab(tab))
    }

    if ( // on account level there are only account devices and qid products
        (!accountSubsystems && activeTab === SIL_MODEL_ACCOUNT_SUBSYSTEMS)
        || (!projectDevices && activeTab === SIL_MODEL_PROJECT_DEVICES)
        || (!projectSubsystems && activeTab === SIL_MODEL_PROJECT_SUBSYSTEMS)
    ) {
        activeTab = SIL_MODEL_ACCOUNT_DEVICES
    }

    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.selectDevice}</PageTitle>
            </PageHeader>
            <PageContent>
                <PageMenu>
                    {
                        accountDevices && (
                            <PageMenuButton
                                isActive={activeTab === SIL_MODEL_ACCOUNT_DEVICES}
                                onClick={() => setActiveTab(SIL_MODEL_ACCOUNT_DEVICES)}
                            >
                                {lang.accountDevices}
                            </PageMenuButton>
                        )
                    }
                    {
                        accountSubsystems && (
                            <PageMenuButton
                                isActive={activeTab === SIL_MODEL_ACCOUNT_SUBSYSTEMS}
                                onClick={() => setActiveTab(SIL_MODEL_ACCOUNT_SUBSYSTEMS)}
                            >
                                {lang.accountSubsystems}
                            </PageMenuButton>
                        )
                    }
                    {
                        projectDevices && (
                            <PageMenuButton
                                isActive={activeTab === SIL_MODEL_PROJECT_DEVICES}
                                onClick={() => setActiveTab(SIL_MODEL_PROJECT_DEVICES)}
                            >
                                {lang.projectDevices}
                            </PageMenuButton>
                        )
                    }
                    {
                        projectSubsystems && (
                            <PageMenuButton
                                isActive={activeTab === SIL_MODEL_PROJECT_SUBSYSTEMS}
                                onClick={() => setActiveTab(SIL_MODEL_PROJECT_SUBSYSTEMS)}
                            >
                                {lang.projectSubsystems}
                            </PageMenuButton>
                        )
                    }
                    {
                        qidProducts && (
                            <PageMenuButton
                                isActive={activeTab === SIL_MODEL_QID_PRODUCTS}
                                onClick={() => setActiveTab(SIL_MODEL_QID_PRODUCTS)}
                            >
                                {lang.qidProducts}
                            </PageMenuButton>
                        )
                    }
                </PageMenu>

                {
                    accountDevices && (
                        <Tab show={activeTab === SIL_MODEL_ACCOUNT_DEVICES}>
                            <AccountDevices />
                        </Tab>
                    )
                }
                {
                    accountSubsystems && (
                        <Tab show={activeTab === SIL_MODEL_ACCOUNT_SUBSYSTEMS}>
                            <AccountSubsystems />
                        </Tab>
                    )
                }
                {
                    projectDevices && (
                        <Tab show={activeTab === SIL_MODEL_PROJECT_DEVICES}>
                            <ProjectDevices />
                        </Tab>
                    )
                }
                {
                    projectSubsystems && (
                        <Tab show={activeTab === SIL_MODEL_PROJECT_SUBSYSTEMS}>
                            <ProjectSubsystems />
                        </Tab>
                    )
                }
                {
                    qidProducts && (
                        <Tab show={activeTab === SIL_MODEL_QID_PRODUCTS}>
                            <QidProducts />
                        </Tab>
                    )
                }
            </PageContent>
        </Container>
    )
}
export default ModelDevices
